import useMediaQuery from "./useMediaQuery"

export function useIsTablet() {
  const breakpoint = getComputedStyle(document.body).getPropertyValue(
    "--breakpoint-tablet"
  )
  return useMediaQuery(`(min-width: ${breakpoint})`)
}

export function useIsDesktop() {
  const breakpoint = getComputedStyle(document.body).getPropertyValue(
    "--breakpoint-desktop"
  )
  return useMediaQuery(`(min-width: ${breakpoint})`)
}

export function useIsDesktopLarge() {
  const breakpoint = getComputedStyle(document.body).getPropertyValue(
    "--breakpoint-desktop-large"
  )
  return useMediaQuery(`(min-width: ${breakpoint})`)
}

export function useIsDesktopHuge() {
  const breakpoint = getComputedStyle(document.body).getPropertyValue(
    "--breakpoint-desktop-huge"
  )
  return useMediaQuery(`(min-width: ${breakpoint})`)
}
